module.exports = __webpack_public_path__ + "img/Users-background-green.fa432079.svg";